const LoginDefault = () => import('@/pages/login/login-default');
const registration = () => import('@/pages/registration/registration');
const forgetPassword = () => import('@/pages/registration/forgetPassword');

export default [
    {
        path: '/login',
        name: 'Login',
        component: LoginDefault,
        meta: {
            layout: true
        }
    },
    {
        path: '/registration',
        name: 'registration',
        component: registration,
        meta: {
            layout: true
        }
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: forgetPassword,
        meta: {
            layout: true
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/login/login.js